export const requestCancelMessage = "Request cancelled";